import React, { useContext } from "react";
import Header from "./Components/Header";
import ListItem from "./Components/ListItem";
import styles from "./index.module.scss";
import useRequest from "../../../../utils/useRequest";
import { findDiscussList } from "../../../../service/discuss";
import { CourseContext } from "../../Store";
import { Spin } from "antd";
import CustomEmpty from "../../../../components/CourseComponents/CustomEmpty";

export default function DiscussList() {
    const {
        course: { courseNo, batchNo, courseSeq, weekTimeId }
    } = useContext(CourseContext);

    const [data, { loading }, refresh] = useRequest(() =>
        findDiscussList({
            courseNo,
            batchNo: batchNo!,
            courseSeq,
            weektimeId: weekTimeId
        })
    );

    return (
        <div className={styles.root}>
            <Header count={data?.length || 0} onChange={refresh} />

            <Spin spinning={loading}>
                <div className={styles.list}>
                    {data?.map(item => (
                        <ListItem
                            key={item.uuid}
                            data={item}
                            onChange={refresh}
                        />
                    ))}
                </div>

                {data?.length === 0 && (
                    <CustomEmpty
                        style={{ padding: "100px 0" }}
                        description="没有主题讨论"
                    />
                )}
            </Spin>
        </div>
    );
}
